import isNumber from 'lodash/isNumber';
import { VARIANTS_BOATS_BRAND, VARIANTS_BOATS_HORSE_POWER_MAX, VARIANTS_BOATS_HORSE_POWER_MIN, VARIANTS_BOATS_LENGTH, VARIANTS_BOATS_TYPE, VARIANTS_DRIVER_LICENSE_CATEGORY, VARIANTS_EBIKE_RIDING_TYPE, VARIANTS_EBIKE_WHEEL_SIZE, VARIANTS_MOTORCYCLES_LIMITED_POWER_VERSION, VARIANTS_MOTORCYCLES_POWER, VARIANTS_OUTBOARD_ENGINE_CONFIGURATION, VARIANTS_OUTBOARD_ENGINE_STEERING, VARIANTS_OUTBOARD_ENGINE_WEIGHT_MAX, VARIANTS_OUTBOARD_ENGINE_WEIGHT_MIN, VARIANTS_SCOOTERS_ENGINE_SIZE, VARIANTS_SCOOTERS_POWER, VARIANTS_SCOOTERS_STORAGE, VARIANTS_SNOWMOBILES_CYLINDERS, VARIANTS_SNOWMOBILES_DISPLACEMENT, VARIANTS_SNOWMOBILES_TYPE, VARIANTS_WAVE_RUNNERS_DRY_WEIGHT, VARIANTS_WAVE_RUNNERS_ENGINE_SIZE, VARIANTS_WAVE_RUNNERS_SUPER_CHARGED, FilterType, } from '@yme/common/constants';
import { AVAILABLE_DRIVER_LICENCE_KEY } from './constants';
export function getFilterLabelKey(filterId) {
    switch (filterId) {
        case VARIANTS_DRIVER_LICENSE_CATEGORY:
            return 'productsGrid_driversLicenseRequiredFilter_label';
        case VARIANTS_EBIKE_RIDING_TYPE:
            return 'productsGrid_ridingTypeFilter_label';
        case VARIANTS_EBIKE_WHEEL_SIZE:
            return 'productsGrid_wheelSizeFilter_label';
        case VARIANTS_MOTORCYCLES_LIMITED_POWER_VERSION:
            return 'productsGrid_thirtyFiveKwVersionAvailableFilter_label';
        case VARIANTS_MOTORCYCLES_POWER:
            return 'productsGrid_maximumPowerFilter_label';
        case VARIANTS_SCOOTERS_STORAGE:
            return 'productsGrid_storageFilter_label';
        case VARIANTS_SCOOTERS_POWER:
            return 'productsGrid_maximumPowerFilter_label';
        case VARIANTS_SCOOTERS_ENGINE_SIZE:
            return 'productsGrid_engineSizeFilter_label';
        case VARIANTS_WAVE_RUNNERS_ENGINE_SIZE:
            return 'productsGrid_engineSizeFilter_label';
        case VARIANTS_WAVE_RUNNERS_SUPER_CHARGED:
            return 'productsGrid_superChargedFilter_label';
        case VARIANTS_WAVE_RUNNERS_DRY_WEIGHT:
            return 'productsGrid_dryWeightFilter_label';
        case VARIANTS_BOATS_LENGTH:
            return 'productsGrid_lengthFilter_label';
        case VARIANTS_BOATS_TYPE:
            return 'productsGrid_boatTypeFilter_label';
        case VARIANTS_BOATS_BRAND:
            return 'productsGrid_boatBrandFilter_label';
        case VARIANTS_BOATS_HORSE_POWER_MIN:
        case VARIANTS_BOATS_HORSE_POWER_MAX:
            return 'productsGrid_horsepowerRangeFilter_label';
        case VARIANTS_OUTBOARD_ENGINE_WEIGHT_MIN:
        case VARIANTS_OUTBOARD_ENGINE_WEIGHT_MAX:
            return 'productsGrid_dryWeightFilter_label';
        case VARIANTS_OUTBOARD_ENGINE_CONFIGURATION:
            return 'productsGrid_configuration_label';
        case VARIANTS_OUTBOARD_ENGINE_STEERING:
            return 'productsGrid_steeringFilter_label';
        case VARIANTS_SNOWMOBILES_TYPE:
            return 'productsGrid_typeFilter_label';
        case VARIANTS_SNOWMOBILES_DISPLACEMENT:
            return 'productsGrid_displacementFilter_label';
        case VARIANTS_SNOWMOBILES_CYLINDERS:
            return 'productsGrid_cylindersFilter_label';
        default:
            return '';
    }
}
export function getPlaceholderLabelKey(filterType) {
    switch (filterType) {
        case FilterType.CHECKLIST:
            return 'filters_selectOptions_placeholder';
        case FilterType.RANGE:
            return 'filters_chooseRange_placeholder';
        case FilterType.TOGGLE:
        default:
            return 'filters_chooseOption_placeholder';
    }
}
export function getFilterType(filterFacetsConfig, id) {
    return (filterFacetsConfig.find((filterFacet) => filterFacet.id === id)?.type ?? FilterType.CHECKLIST);
}
export function getMeasurementUnit(filterFacetsConfig, id) {
    return filterFacetsConfig.find((filterFacet) => filterFacet.id === id)?.unit ?? '';
}
export function getPlaceHolder({ filterType, values, measurementUnit, rangeMax = undefined, isRightToLeft, }) {
    switch (filterType) {
        case FilterType.RANGE:
            return isNumber(values[0]?.rangeLow) && isNumber(values[0]?.rangeHigh)
                ? isRightToLeft
                    ? `${values[0].rangeHigh}${measurementUnit} - ${values[0].rangeLow}${measurementUnit}`
                    : `${values[0].rangeLow}${measurementUnit} - ${values[0].rangeHigh}${measurementUnit}`
                : '';
        case FilterType.RANGE_MIN:
            return rangeMax && isNumber(values[0]?.rangeLow) && isNumber(rangeMax[0]?.rangeHigh)
                ? isRightToLeft
                    ? `${rangeMax[0].rangeHigh}${measurementUnit} - ${values[0].rangeLow}${measurementUnit}`
                    : `${values[0].rangeLow}${measurementUnit} - ${rangeMax[0].rangeHigh}${measurementUnit}`
                : '';
        default:
            return '';
    }
}
export const setAvailableDriverLicenceToLocalStorage = (data) => {
    const driverLicences = data.find((item) => item.id === VARIANTS_DRIVER_LICENSE_CATEGORY);
    if (driverLicences?.values) {
        const values = driverLicences?.values.map((licence) => licence.value);
        localStorage.setItem(AVAILABLE_DRIVER_LICENCE_KEY, JSON.stringify(values));
        const event = new CustomEvent('localStorageAvailableLicencesChange', {
            detail: {
                key: AVAILABLE_DRIVER_LICENCE_KEY,
                newValue: JSON.stringify(values),
                type: 'setItem',
            },
        });
        window.dispatchEvent(event);
    }
};
